import { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import i18n from "../../i18n-config";
import {
  CustomAvatar,
  CustomButton,
  CustomLoader,
} from "../../components";
import { AddPhotoICON } from "../../assets/icons";
import { batch, useDispatch } from "react-redux";
import { getAsyncOffre, Offre } from "../../store/features/offreSlice";
import { useParams } from "react-router-dom";
import PositionementCard from "./component/PositionementCard";
import BaraGrouilleurModal from "./component/BaraGrouilleurModal";

function BaraDetail() {

  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id || "";

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<Offre>({
    titre: "",
    description: "",
    adresse: "",
    localisation: "",
    dateDemarrageSouhaiter: "",
    paiementGrouilleur: "JOURNEE",
    avecMateriel: false,
    devis: false,
    previsite: false,
    idSousCategorie: undefined,
    idCategorie: undefined,
  });
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null) as any;
  const handleShowOpen = () => setShow(!show);
  
    const callback = (item: any) => {
      setData(item);
    };

  const toggleLoader = () => {
    setLoading(!loading);
  };
  
  const getData = () => {
    batch(() => {
      dispatch(getAsyncOffre(id, callback) as any);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const isEmpty = true;

  return (
    <Box sx={{ backgroundColor: "#F9F9F9", minHeight: "100vh" }} p={3} pt={6}>
      <Typography fontSize={22} fontWeight="600" mb={2}>
        {i18n.t("mes_dossiers")}
      </Typography>
      <Box
        sx={{
          p: 3,
          backgroundColor: "white",
          boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
          borderRadius: "5px",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{ border: "1px solid #B5BAB5", borderRadius: "5px" }}
          mb={3}
          p={1.5}
        >
          <Typography fontWeight="600" color="#3D423F" mb={2}>
            {i18n.t("details_bara")}
          </Typography>

          <Grid container>
            <Grid item xs={4}>
              <Typography fontSize={14} color="#3D423F" fontWeight={400}>
                {i18n.t("intitule_bara")}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontSize={14} color="#3D423F" fontWeight={400}>
                {i18n.t("categorie_souscat")}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontSize={14} color="#3D423F" fontWeight={400}>
                {i18n.t("localisation_bara")}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Grid container>
            <Grid item xs={4}>
              <Typography fontSize={14} fontWeight={500}>
                {data?.titre}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontSize={14} fontWeight={500}>
                {data?.categorie?.libelle}/{data?.sousCategorie?.libelle}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontSize={14} fontWeight={500}>
                {data?.adresse}
              </Typography>
            </Grid>
          </Grid>

          <Typography fontSize={14} fontWeight={500} mt={4} mb={2}>
            {i18n.t("description_bara")}
          </Typography>

          <Box p={2} sx={{ backgroundColor: "#3D423F10" }}>
            <Typography fontSize={14} fontWeight={500}>
              {data?.description}
            </Typography>
          </Box>

          <Typography fontSize={14} fontWeight={500} mt={4} mb={2}>
            {i18n.t("photo_lieux")}
          </Typography>

          <Stack direction={"row"} alignItems="center" spacing={2}>
            <CustomAvatar
              avatarStyle={{ width: 167, height: 130, borderRadius: 0 }}
            />
            <CustomAvatar
              avatarStyle={{ width: 167, height: 130, borderRadius: 0 }}
            />
            <CustomAvatar
              avatarStyle={{ width: 167, height: 130, borderRadius: 0 }}
            />
            <IconButton sx={{ borderRadius: 2, height: 70 }}>
              <AddPhotoICON />
            </IconButton>
          </Stack>
        </Box>

        <Box
          sx={{ border: "1px solid #B5BAB5", borderRadius: "5px", height: 250 }}
          mb={3}
          p={1.5}
        >
          <Typography fontWeight="600" color="#3D423F" mb={2}>
            {i18n.t("informations_positionnement")}
          </Typography>

          {!isEmpty ? (
            <Stack direction="row" justifyContent={"space-between"}>
              <Box>
                <PositionementCard />
                <PositionementCard />
                <PositionementCard />
                <PositionementCard />
              </Box>

              <Box
                style={{
                  width: 1,
                  minHeight: "100%",
                  backgroundColor: "#c2c2c2",
                }}
              />

              <Stack alignItems={"center"} justifyContent="center" mr={5}>
                <Typography fontWeight="500" fontSize={14} mb={1}>
                  {i18n.t("affecter_grouilleur")}
                </Typography>
                <Typography
                  fontWeight="400"
                  fontSize={12}
                  color="#3D423F"
                  mb={5}
                >
                  {i18n.t("affecter_grouilleur_bara")}
                </Typography>
                <CustomButton
                  title={i18n.t("affecter")}
                  rootStyle={{ width: 120 }}
                />
              </Stack>
            </Stack>
          ) : (
            <Stack alignItems={"center"} justifyContent="center" height="100%">
              <CustomButton
                title={i18n.t("proposer_grouilleur")}
                rootStyle={{ width: 245 }}
                onClick={handleShowOpen}
              />
            </Stack>
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Box
              sx={{
                border: "1px solid #B5BAB5",
                borderRadius: "5px",
                height: 380,
              }}
              mb={2}
              p={1.5}
            >
              <Typography fontWeight="600" color="#3D423F" mb={4}>
                {i18n.t("detail_boss")}
              </Typography>

              <Stack direction={"row"} justifyContent="space-between" mb={2}>
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("nom_boss")}
                </Typography>
                <Typography color="#3D423F" fontSize={14}>
                  {`${data?.boss?.nom} ${data?.boss?.prenom}`}
                </Typography>
              </Stack>

              <Stack direction={"row"} justifyContent="space-between" mb={2}>
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("numero_telephone")}
                </Typography>
                <Typography color="#3D423F" fontSize={14}>
                  ---
                </Typography>
              </Stack>

              <Stack direction={"row"} justifyContent="space-between" mb={2}>
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("adress_bara")}
                </Typography>
                <Typography color="#3D423F" fontSize={14}>
                  {data?.adresse}
                </Typography>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                border: "1px solid #B5BAB5",
                borderRadius: "5px",
                height: 380,
              }}
              mb={2}
              p={1.5}
            >
              <Typography fontWeight="600" color="#3D423F" mb={4}>
                {i18n.t("details_grouilleur")}
              </Typography>

              <Stack
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
                mb={2}
              >
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("nom_grouilleur")}
                </Typography>
                <OutlinedInput size="small" sx={{ width: 250 }} />
              </Stack>

              <Stack
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
                mb={2}
              >
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("localisation")}
                </Typography>
                <OutlinedInput size="small" sx={{ width: 250 }} />
              </Stack>

              <Stack
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
                mb={2}
              >
                <Typography color="#3D423F" fontSize={14}>
                  {i18n.t("numero_telephone")}
                </Typography>
                <OutlinedInput size="small" sx={{ width: 250 }} />
              </Stack>

              <Stack direction={"row"} justifyContent={"center"}>
                <CustomButton
                  title={i18n.t("valider")}
                  rootStyle={{ width: 150, marginTop: 5 }}
                />
              </Stack>
            </Box>
          </Grid>
        </Grid>

        <Stack direction="row" alignItems={"center"}>
          <Typography fontWeight={500} fontSize={14} mr={4}>
            {i18n.t("considerer_bara_ouvert")}
          </Typography>
          <FormControlLabel control={<Checkbox />} label={i18n.t("oui")} />
          <FormControlLabel control={<Checkbox />} label={i18n.t("non")} />
        </Stack>
      </Box>

      <CustomLoader open={loading} handleClose={toggleLoader} />
      <BaraGrouilleurModal open={show} onClose={handleShowOpen} />
    </Box>
  );
}

export default BaraDetail;
